/**
 * Secondipity Product Page — Gallery, Tabs, Variant Picker, Quantity, Video
 * Shared by single-product.html and single-product-variant.html; the
 * variant-picker and warranty-picker blocks below simply no-op on whichever
 * page doesn't render that markup (their selectors match zero elements).
 */

$(function () {
    'use strict';

    // -------------------------------------------------------------------------
    // 1. Media Gallery — main Swiper + thumbnail Swiper linked via Swiper's
    // own thumbs module (native "click a thumb, main image follows" support).
    // -------------------------------------------------------------------------
    if ($('.product-main-swiper').length && typeof Swiper !== 'undefined') {
        // product-gallery.liquid only renders .product-thumbs-swiper when
        // the product has more than one image — initializing Swiper against
        // a selector that matches nothing throws synchronously and would
        // abort this whole $(function(){...}) callback, taking every
        // feature after it (tabs, qty stepper, variant picker, share) down
        // with it on single-image products.
        const thumbsSwiper = $('.product-thumbs-swiper').length
            ? new Swiper('.product-thumbs-swiper', {
                slidesPerView: 10,
                spaceBetween: 10,
                watchSlidesProgress: true,
                grabCursor: true,
            })
            : null;

        window.productMainSwiper = new Swiper('.product-main-swiper', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.gallery-nav-next',
                prevEl: '.gallery-nav-prev',
            },
            thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
            on: {
                // "1 / 13" counter shown on phones (see .gallery-counter)
                slideChange: function (swiper) {
                    $('.gallery-counter-current').text(swiper.activeIndex + 1);
                },
            },
        });
    }

    // -------------------------------------------------------------------------
    // 2. Product Tabs — Description / Specifications / FAQs
    // -------------------------------------------------------------------------
    // "Reviews" tab: a shortcut to the reviews section further down (the
    // page renders a single Judge.me widget). Hidden when there's none.
    $('.product-tab-btn[data-scroll-to]').each(function () {
        const target = document.querySelector(this.getAttribute('data-scroll-to'));
        this.hidden = !target;
    });

    $('.product-tab-btn').on('click', function () {
        const $btn = $(this);
        const scrollTarget = $btn.attr('data-scroll-to');
        if (scrollTarget) {
            const target = document.querySelector(scrollTarget);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        const tab = $btn.data('tab');

        $('.product-tab-btn').removeClass('is-active').attr('aria-selected', 'false');
        $btn.addClass('is-active').attr('aria-selected', 'true');

        $('.product-tab-panel').prop('hidden', true).removeClass('is-active');
        $(`.product-tab-panel[data-tab-panel="${tab}"]`).prop('hidden', false).addClass('is-active');
    });

    // -------------------------------------------------------------------------
    // 3. Quantity Stepper (buy box)
    // -------------------------------------------------------------------------
    const $qtyInput = $('#productQtyInput');
    if ($qtyInput.length) {
        const min = parseInt($qtyInput.attr('min'), 10) || 1;
        const max = parseInt($qtyInput.attr('max'), 10) || 99;

        $('#productQtyStepper .qty-minus').on('click', () => {
            const val = Math.max(min, (parseInt($qtyInput.val(), 10) || min) - 1);
            $qtyInput.val(val);
        });

        $('#productQtyStepper .qty-plus').on('click', () => {
            const val = Math.min(max, (parseInt($qtyInput.val(), 10) || min) + 1);
            $qtyInput.val(val);
        });

        $qtyInput.on('change', () => {
            let val = parseInt($qtyInput.val(), 10);
            if (isNaN(val)) val = min;
            $qtyInput.val(Math.min(Math.max(val, min), max));
        });
    }

    // -------------------------------------------------------------------------
    // 4. Variant Picker (single-product-variant.html only — matches 0
    // elements, and so no-ops entirely, on single-product.html)
    // Shopify: this whole block is a stand-in for matching product.variants
    // against the selected options and swapping in the real variant's id/
    // price/image/availability instead of just relabeling the UI.
    // -------------------------------------------------------------------------
    const $colorSwatches = $('#colorSwatches .variant-swatch');
    const $colorLabel = $('#selectedColorLabel');

    // Listen for custom variant change event from main-product.liquid
    document.addEventListener('variant:change', function (e) {
        const variant = e.detail && e.detail.variant;
        if (!variant) return;

        if (variant.featured_media && window.productMainSwiper) {
            const mediaId = variant.featured_media.id;
            const $slides = $('.product-main-swiper .swiper-slide');
            $slides.each(function (idx) {
                if ($(this).data('media-id') == mediaId) {
                    window.productMainSwiper.slideTo(idx);
                    return false;
                }
            });
        }
    });

    const $sizeOptions = $('#sizeOptions .variant-size-option');
    const $sizeLabel = $('#selectedSizeLabel');

    $sizeOptions.on('click', function () {
        const $option = $(this);
        if ($option.prop('disabled')) return;
        $sizeOptions.removeClass('is-active');
        $option.addClass('is-active');
        $sizeLabel.text($option.data('size'));
    });

    // -------------------------------------------------------------------------
    // 4b. Share button — dropdown with social share links (Facebook, X,
    // Pinterest, WhatsApp, Email) + copy-to-clipboard, instead of jumping
    // straight to the OS share sheet, so the networks are actually visible
    // and clickable in the page itself.
    // -------------------------------------------------------------------------
    // Desktop button (#productShareBtn, price row) + the phone one on the
    // rating row; both toggle the same panel, which is positioned under
    // whichever button was clicked.
    const $shareBtns = $('.product-share-btn');
    let $shareBtn = $('#productShareBtn');
    const $sharePanel = $('#productSharePanel');

    if ($shareBtn.length && $sharePanel.length) {
        const pageUrl = window.location.href;
        const encodedUrl = encodeURIComponent(pageUrl);
        const encodedTitle = encodeURIComponent(document.title);
        const encodedImage = encodeURIComponent($shareBtn.data('image') || '');

        $sharePanel.find('[data-share="facebook"]').attr('href', `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`);
        $sharePanel.find('[data-share="twitter"]').attr('href', `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`);
        $sharePanel.find('[data-share="pinterest"]').attr('href', `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`);
        $sharePanel.find('[data-share="whatsapp"]').attr('href', `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`);
        $sharePanel.find('[data-share="email"]').attr('href', `mailto:?subject=${encodedTitle}&body=${encodedUrl}`);

        const closeSharePanel = () => {
            $sharePanel.removeClass('is-open').attr('aria-hidden', 'true');
            $shareBtns.attr('aria-expanded', 'false');
        };

        // .product-share-panel is position: fixed (see product.css) so it can
        // escape .product-buybox's overflow-y: auto clipping once the buybox
        // is tall enough to scroll (e.g. a product with a variant picker) —
        // that takes it out of .product-share-wrap's normal flow, so its
        // position has to be computed from the button's viewport position.
        const positionSharePanel = () => {
            const btnRect = $shareBtn[0].getBoundingClientRect();
            const panelWidth = $sharePanel.outerWidth();
            const left = Math.max(8, btnRect.right - panelWidth);
            const top = btnRect.bottom + 8;
            $sharePanel.css({ top: top + 'px', left: left + 'px' });
        };

        const openSharePanel = () => {
            positionSharePanel();
            $sharePanel.addClass('is-open').attr('aria-hidden', 'false');
            $shareBtn.attr('aria-expanded', 'true');
        };

        $shareBtns.on('click', function (e) {
            e.stopPropagation();
            if ($sharePanel.hasClass('is-open')) {
                closeSharePanel();
            } else {
                $shareBtn = $(this);
                openSharePanel();
            }
        });

        $(document).on('click', function (e) {
            if (!$(e.target).closest('.product-share-wrap, .product-share-btn').length) closeSharePanel();
        });

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') closeSharePanel();
        });

        // Fixed positioning is computed once on open, so a scroll (e.g. the
        // scrollable .product-buybox on a variant product) would otherwise
        // leave the panel floating over the wrong spot — just close it.
        $(window).on('scroll resize', function () {
            if ($sharePanel.hasClass('is-open')) closeSharePanel();
        });
        $('.product-buybox').on('scroll', function () {
            if ($sharePanel.hasClass('is-open')) closeSharePanel();
        });

        $sharePanel.on('click', 'a.product-share-option', closeSharePanel);

        $('#productShareCopyBtn').on('click', async function () {
            const $label = $(this).find('.product-share-option-label');
            const original = $label.text();
            try {
                await navigator.clipboard.writeText(pageUrl);
                $label.text('Copied!');
            } catch (err) {
                $label.text('Copy failed');
            }
            setTimeout(() => $label.text(original), 1800);
            closeSharePanel();
        });
    }

    // -------------------------------------------------------------------------
    // 4c. Shop Pay Installments — forward a click on our tooltip icon (in
    // .product-installments) to Shopify's own real widget
    // ({{ form | payment_terms }}, visually hidden in
    // #shopPayInstallmentsWidget — see product.css) so it opens Shopify's
    // native "Sample plans" modal.
    //
    // SPECULATIVE / UNVERIFIED: Shop Pay Installments is not enabled on
    // this shop as of this writing, so `.shopify-payment-terms` renders
    // empty and this silently no-ops — the existing hover tooltip
    // (data-tooltip) is all that shows, same as before. The exact element
    // Shopify injects inside that div isn't documented and isn't
    // inspectable here without the payment method being live, so rather
    // -------------------------------------------------------------------------
    // 5. Shop Pay Installments & Modal (Verdi Style)
    // -------------------------------------------------------------------------
    function calculateInstallmentPlans(cents) {
        const dollars = cents / 100;
        const biweekly = (dollars / 4).toFixed(2);
        // Affirm standard 12-month APR (~15%): monthly multiplier approx 0.090258
        const monthly = (dollars * 0.090258).toFixed(2);
        const monthlyTotal = (parseFloat(monthly) * 12).toFixed(2);
        const monthlyInterest = (parseFloat(monthlyTotal) - dollars).toFixed(2);

        return {
            cents: cents,
            dollars: dollars.toFixed(2),
            biweekly: biweekly,
            monthly: monthly,
            monthlyTotal: monthlyTotal,
            monthlyInterest: monthlyInterest,
            isEligible12Mo: dollars >= 50
        };
    }

    function updateInstallmentsUI(priceCents) {
        const plans = calculateInstallmentPlans(priceCents);
        const $textWrap = $('#productInstallmentsText');
        if ($textWrap.length) {
            $textWrap.attr('data-price', priceCents);
            let phrase = '';
            if (plans.isEligible12Mo) {
                phrase = `4 interest-free installments, or from <strong class="installments-amount">$${plans.monthly}</strong>/mo with`;
            } else {
                phrase = `4 interest-free installments of <strong class="installments-amount">$${plans.biweekly}</strong> with`;
            }
            $textWrap.find('.installments-phrase').html(phrase);
        }

        // Update modal values
        $('#shopPayModalPrice').text(`$${plans.dollars}`);
        $('#shopPayPlanBiweeklyHeadline').text(`$${plans.biweekly} every 2 weeks for 6 weeks`);
        $('#shopPayPlanBiweeklyTotal').text(`$${plans.dollars}`);
        $('#shopPayPlanMonthlyHeadline').text(`$${plans.monthly} every month for 12 months`);
        $('#shopPayPlanMonthlyInterest').text(`$${plans.monthlyInterest}`);
        $('#shopPayPlanMonthlyTotal').text(`$${plans.monthlyTotal}`);
    }

    // Initialize installments UI with initial variant
    const initialPriceAttr = $('#productInstallmentsText').data('price');
    if (initialPriceAttr) {
        updateInstallmentsUI(parseInt(initialPriceAttr, 10));
    }

    // Open Shop Pay Modal
    function openShopPayModal() {
        $('#shopPayModal').css('display', 'flex').attr('aria-hidden', 'false');
        $('body').addClass('modal-open');
    }

    function closeShopPayModal() {
        $('#shopPayModal').css('display', 'none').attr('aria-hidden', 'true');
        $('body').removeClass('modal-open');
    }

    $('#shopPayInfoTrigger').on('click', function (e) {
        e.preventDefault();
        // Check if Shopify has real Shop Pay Installments widget rendered
        const $realWidget = $('#shopPayInstallmentsWidget');
        const $realTrigger = $realWidget.find('a, button, [role="button"], [tabindex]').first();
        if ($realTrigger.length && $realTrigger.is(':visible')) {
            $realTrigger[0].click();
            return;
        }
        openShopPayModal();
    });

    $('#shopPayModalClose, #shopPayModal').on('click', function (e) {
        if (e.target === this || $(this).is('#shopPayModalClose')) {
            closeShopPayModal();
        }
    });

    $('#shopPayModalContinueBtn').on('click', function () {
        closeShopPayModal();
        const $form = $('#product-form-pdp');
        if ($form.length) {
            $form.find('button[type="submit"]').trigger('click');
        }
    });

    // -------------------------------------------------------------------------
    // 6. Extended Warranty Picker (SureBright Style)
    // -------------------------------------------------------------------------
    function calculateWarrantyTiers(cents) {
        const dollars = cents / 100;
        let y1, y2, y3;
        if (dollars < 50) {
            y1 = '7.99'; y2 = '12.99'; y3 = '17.99';
        } else if (dollars < 100) {
            y1 = '14.99'; y2 = '22.99'; y3 = '29.99';
        } else if (dollars < 250) {
            y1 = '24.99'; y2 = '36.99'; y3 = '46.99';
        } else if (dollars < 500) {
            y1 = '39.99'; y2 = '59.99'; y3 = '74.99';
        } else if (dollars < 1000) {
            y1 = '49.99'; y2 = '74.99'; y3 = '89.99';
        } else {
            y1 = '79.99'; y2 = '119.99'; y3 = '149.99';
        }
        return { 1: y1, 2: y2, 3: y3 };
    }

    function updateWarrantyUI(cents) {
        const tiers = calculateWarrantyTiers(cents);
        $('.warranty-option').each(function () {
            const years = $(this).data('years');
            const price = tiers[years];
            if (price) {
                $(this).data('price', price);
                $(this).find('.warranty-option-price').text(`$${price}`);
            }
        });
        // If an option is active, update the property value
        const $activeOpt = $('.warranty-option.is-active');
        if ($activeOpt.length) {
            const y = $activeOpt.data('years');
            const p = tiers[y];
            $('#productWarrantyProperty').val(`+${y} Year Extended Warranty ($${p})`);
        }
    }

    if (initialPriceAttr) {
        updateWarrantyUI(parseInt(initialPriceAttr, 10));
    }

    // Toggle warranty selection
    $('.warranty-option').on('click', function () {
        const $this = $(this);
        const isAlreadyActive = $this.hasClass('is-active');

        $('.warranty-option').removeClass('is-active');

        if (isAlreadyActive) {
            // Deselect
            $('#productWarrantyProperty').val('');
        } else {
            // Select
            $this.addClass('is-active');
            const years = $this.data('years');
            const price = $this.find('.warranty-option-price').text();
            $('#productWarrantyProperty').val(`+${years} Year Extended Warranty (${price})`);
        }
    });

    // What's Covered Modal
    function openWarrantyModal() {
        $('#warrantyWhatsCoveredModal').css('display', 'flex').attr('aria-hidden', 'false');
        $('body').addClass('modal-open');
    }

    function closeWarrantyModal() {
        $('#warrantyWhatsCoveredModal').css('display', 'none').attr('aria-hidden', 'true');
        $('body').removeClass('modal-open');
    }

    $('#warrantyWhatsCoveredTrigger').on('click', function (e) {
        e.preventDefault();
        openWarrantyModal();
    });

    $('#warrantyModalClose, #warrantyModalGotItBtn, #warrantyWhatsCoveredModal').on('click', function (e) {
        if (e.target === this || $(this).is('#warrantyModalClose, #warrantyModalGotItBtn')) {
            closeWarrantyModal();
        }
    });

    // Close any modal on ESC key
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            closeShopPayModal();
            closeWarrantyModal();
        }
    });

    // Listen for custom variant change event
    document.addEventListener('variant:change', function (e) {
        const variant = e.detail && e.detail.variant;
        if (!variant) return;

        if (variant.price) {
            updateInstallmentsUI(variant.price);
            updateWarrantyUI(variant.price);
        }
    });

    // -------------------------------------------------------------------------
    // 6. Product Video — handled by sections/product-video.liquid itself.
    // -------------------------------------------------------------------------

    // -------------------------------------------------------------------------
    // 7. Shared Smooth Accordion — condition rows + both FAQ sections + the
    // FAQs tab panel all reuse the same .accordion-row component/behavior.
    // -------------------------------------------------------------------------
    window.Secondipity.initSmoothDetails('.accordion-row');
});


// Card alert links reuse the native Klaviyo variant-aware dialog on the product page.
(function(){
 if(location.hash!=='#stock-alert')return;
 let opened=false;
 function openAlert(){
  if(opened)return;
  const button=document.querySelector('.product-qty-cart-row button[data-a11y-identifier^="bis-button-"]');
  if(!button||button.disabled)return;
  opened=true;observer.disconnect();clearTimeout(stop);
  button.scrollIntoView({block:'center',behavior:'auto'});button.focus({preventScroll:true});button.click();
 }
 const observer=new MutationObserver(openAlert);
 observer.observe(document.body,{childList:true,subtree:true});
 const stop=setTimeout(function(){observer.disconnect();},15000);
 openAlert();
})();